import { useContext } from "react";
import { Navbar, Nav, Container } from 'react-bootstrap';
import { AuthContext } from "../Login/AuthContext";

function NavbarComponent() {
  const { user, logout, idleCountDown } = useContext(AuthContext);

  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary" data-bs-theme="dark">
      <Container>
        <Navbar.Brand href="/">HGCAL DB</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">HGCAL DB</Nav.Link>
            <Nav.Link href="/ship-list">Shipments</Nav.Link>
            <Nav.Link href="/baseplate-list">Baseplate</Nav.Link>
            <Nav.Link href="/kapton-list">Kapton</Nav.Link>
            <Nav.Link href="/tape-list">Tape</Nav.Link>
            <Nav.Link href="/glue-list">Glue</Nav.Link>
            <Nav.Link href="/material-list">Material</Nav.Link>
            <Nav.Link href="/material-list">Material</Nav.Link>
            <Nav.Link href="/inbound-list">Inbound</Nav.Link>
            <Nav.Link href="/remote-list">Remote</Nav.Link>
            <Nav.Link href="/metrics">Metrics</Nav.Link>
          </Nav>
          <Nav>
            {(idleCountDown <= 2 * 60 * 1000) && <Nav.Link>{`Logout in ${idleCountDown / 1000} (sec.)`}</Nav.Link>}
            <Nav.Link href="/user-list">Users</Nav.Link>
            <Nav.Link>{user?.username}</Nav.Link>
            {user && <Nav.Link onClick={logout} style={{ color: "lightblue", textDecoration: "underline" }}>Logout</Nav.Link>}
            {!user && <Nav.Link href="/login" style={{ color: "lightblue", textDecoration: "underline" }}>Login</Nav.Link>}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
